export const questionnaireAnswerText = (question, answer) => {
  if (answer === undefined || answer === null || answer === "") return "Non renseignée";
  if (question?.type === "choice") {
    return question.config?.options?.find((option) => String(option.id) === String(answer))?.label || String(answer);
  }
  if (question?.type === "yesnomaybe") {
    return { yes: "Oui", maybe: "Peut-être", no: "Non" }[answer] || String(answer);
  }
  if (question?.type === "yesno") return answer === "yes" ? "Oui" : "Non";
  return String(answer);
};

export const questionnaireHistoryText = (questionnaire, record) => {
  const lines = [];
  const questions = Array.isArray(questionnaire?.questions) ? questionnaire.questions : [];
  const fallbackAnswers = Object.entries(record?.answers ?? {}).filter(([, value]) => value !== undefined && value !== null && value !== "");

  if (questions.length > 0) {
    questions.forEach((question, index) => {
      const answer = questionnaireAnswerText(question, record?.answers?.[question.id]);
      lines.push(`${index + 1}. ${question.text || "Question sans titre"} : ${answer}`);
    });
  } else if (fallbackAnswers.length > 0) {
    fallbackAnswers.forEach(([questionId, answer], index) => {
      const answerValue = typeof answer === "object" ? JSON.stringify(answer) : String(answer);
      const humanQuestion = questionnaire?.questions?.find((question) => question.id === questionId)?.text || questionId;
      lines.push(`${index + 1}. ${humanQuestion || "Question sans titre"} : ${answerValue}`);
    });
  } else {
    lines.push("Aucune réponse enregistrée");
  }

  lines.push(`Score total : ${record?.score ?? 0}`);
  return lines.join("\n");
};
